import { render, staticRenderFns } from "./OperaModuleWindow.vue?vue&type=template&id=6cfb01db&scoped=true&"
import script from "./OperaModuleWindow.vue?vue&type=script&lang=js&"
export * from "./OperaModuleWindow.vue?vue&type=script&lang=js&"
import style0 from "./OperaModuleWindow.vue?vue&type=style&index=0&id=6cfb01db&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cfb01db",
  null
  
)

export default component.exports